import fetch from "lib/fetch";
import type { BookingValidationInterface } from "types/bookingValidation";

type BookingValidationResponse = { data: BookingValidationInterface };

export const createBookingValidationRequest = (data: HashMap<unknown>) =>
    fetch.post<BookingValidationResponse>("booking_validation", data);

export const getBookingValidationRequest = (id: string) =>
    fetch.get<BookingValidationResponse>(`booking_validation/${id}`);
